export function hasSubscriptionAccess(user) {
  return Boolean(user?.subscription?.access_granted)
}
